<div class="task-panel-wrapper" [ngClass]="$safeNavigationMigration(phase?.status?.id)">
  <div class="header-full">
    <div class="header-text-wrapper">
      <div class="header-text">{{getType() === "content" ? 'Publish' : "phase?.name"}}</div>
      <div class="header-sub-text">{{getTasks()}}</div>
    </div>
    <div class="spacer"></div>

    @if (getActions().length > 0) {
    <framework-action-dropdown
      [actions]="getActions()"
      [location]="location"
      [task]="getTask()"
      [phase]="phase"
    ></framework-action-dropdown>
    }
    <button styles-icon-button class="icon-button" (click)="expanded = !expanded">
      @if (expanded) {
      <mat-icon>arrow_drop_down</mat-icon>
      } @if (!expanded) {
      <mat-icon>arrow_drop_up</mat-icon>
      }
    </button>
  </div>

  @if (expanded) {
  <ng-container class="phase-body">
    <mat-divider></mat-divider>
    <div class="task-headers">
      <span class="task-headers-name">Task Name</span>
      <span class="task-headers-owner">Owner</span>
      <span class="task-headers-due-date">Due Date</span>
      <span class="task-headers-status">Status</span>
      <span class="task-headers-button"></span>
    </div>
    @if (getType() === "multi") { @for (version of phase?.children; track version) { @if (version.name !== 'Version 1')
    {
    <div class="version-divider">
      <div class="version-divider-name">
        <span class="version-divider-name-text">{{version.name}}</span>
      </div>
      <mat-divider class="version-divider-line"></mat-divider>
    </div>
    } @for (task of version?.children; track task) {
    <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
    } } } @if (getType() === "stage") { @for (task of phase?.children; track task) {
    <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
    } } @if (getType() === "content") { @for (task of phase?.children; track task) {
    <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
    } } @if (getType() === "task") {
    <content-task-row [task]="phase" [phase]="phase" [location]="$any(location)"> </content-task-row>
    }
    <!-- <div class="header-collapsed"></div> -->
    @if (projectHelper.showAssetSlider($safeNavigationMigration(phase?.assets))) {
    <mat-divider class="asset-divider"></mat-divider>
    <framework-dialog-asset-slider
      [allAssets]="$safeNavigationMigration(phase?.assets)"
      [project]="phase | projectPipe"
      [phase]="phase"
      [thumbnailSize]="150"
    >
    </framework-dialog-asset-slider>
    }
  </ng-container>
  }
</div>
